import React from "react";
import { useNavigate } from "react-router-dom";
import ContiPremium from '../imagesHome/conti.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faXmark,
  faCrown
} from "@fortawesome/free-solid-svg-icons";

import "./PremiumPurchasePopup.css";


const PremiumPurchasePopup = ({
  plan,
  onClose
}) => {

  const navigate = useNavigate();


  /* ============================================
     PLANURI
  ============================================ */

  const plans = {

    monthly: {
      name: "Premium Lunar",
      price: "39 LEI",
      period: "/ luna",
      description:
        "Acces complet la ContaLearn cu plata lunara.",
      destination: "/premium/checkout?plan=premium_monthly"
    },

    "three-months": {
      name: "Premium 3 Luni",
      price: "99 LEI",
      period: "/ 3 luni",
      equivalent: "33 LEI/luna",
      saving: "Economisesti 18 LEI",
      description:
        "Acces Premium timp de 3 luni la un pret mai mic pe luna.",
      destination: "/premium/checkout?plan=premium_quarterly"
    }

  };


  const selectedPlan =
    plans[plan];


  /* ============================================
     PLAN INVALID
  ============================================ */

  if (!selectedPlan) {
    return null;
  }


  /* ============================================
     CONTINUA
  ============================================ */

  const handleContinue = () => {

    navigate(
      selectedPlan.destination
    );

  };


  /* ============================================
     RENDER
  ============================================ */

  return (

    <div
      className="premium-purchase-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="premium-purchase-title"
    >

      <div className="premium-purchase-popup">


        {/* CLOSE */}

        <button
          type="button"
          className="premium-purchase-close"
          onClick={onClose}
          aria-label="Inchide"
        >

          <FontAwesomeIcon
            icon={faXmark}
          />

        </button>



        {/* ICON */}

        <div className="premium-purchase-icon">
  <img
    src={ContiPremium}
    alt="Conti Premium"
    className="premium-purchase-conti"
  />
</div>



        {/* HEADER */}

        <div className="premium-purchase-header">

       

          <h2 id="premium-purchase-title">
            {selectedPlan.name}
          </h2>


          <div className="premium-purchase-price">

            <strong>
              {selectedPlan.price}
            </strong>

            <span>
              {selectedPlan.period}
            </span>

          </div>


          {selectedPlan.equivalent && (

            <div className="premium-purchase-equivalent">
              {selectedPlan.equivalent}
            </div>

          )}


          {selectedPlan.saving && (

            <div className="premium-purchase-saving">
              {selectedPlan.saving}
            </div>

          )}


          <p>
            {selectedPlan.description}
          </p>

        </div>



        {/* BENEFICII */}

        <div className="premium-purchase-benefits">


          <div className="premium-purchase-benefit">

            <FontAwesomeIcon
              icon={faCheck}
            />

            <span>
              Acces la toate cursurile ContaLearn
            </span>

          </div>


          <div className="premium-purchase-benefit">

            <FontAwesomeIcon
              icon={faCheck}
            />

            <span>
              Vieti nelimitate
            </span>

          </div>


          <div className="premium-purchase-benefit">

            <FontAwesomeIcon
              icon={faCheck}
            />

            <span>
              Toate modulele deblocate
            </span>

          </div>


          <div className="premium-purchase-benefit">

            <FontAwesomeIcon
              icon={faCheck}
            />

            <span>
              Jocuri educationale Premium
            </span>

          </div>


        </div>



        {/* ACTION */}

        <div className="premium-purchase-actions">

          <button
            type="button"
            className="premium-purchase-continue"
            onClick={handleContinue}
          >
            Continua catre Premium
          </button>


          <button
            type="button"
            className="premium-purchase-later"
            onClick={onClose}
          >
            Continua mai tarziu
          </button>

        </div>


      </div>

    </div>

  );

};


export default PremiumPurchasePopup;